import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faStore, faChevronDown, faChevronUp } from '@fortawesome/free-solid-svg-icons';
import { StoreGroupCardProps } from './types';
import DeviceCard from './DeviceCard';
import {
  StoreCard,
  StoreHeader,
  StoreInfo,
  StoreIconWrapper,
  StoreDetails,
  StoreName,
  MerchantName,
  StoreActions,
  DeviceCountTag,
  ToggleButton,
  ExpandableContent,
  DevicesGrid,
} from './styles';

const StoreGroupCard: React.FC<StoreGroupCardProps> = ({
  storeGroup,
  isDark,
  onEditDevice,
  onDeleteDevice,
}) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const deviceCount = storeGroup.devices.length;
  const countLabel = `${deviceCount} Device${deviceCount !== 1 ? 's' : ''}`;

  return (
    <StoreCard $isDark={isDark}>
      <StoreHeader>
        <StoreInfo>
          <StoreIconWrapper $isDark={isDark}>
            <FontAwesomeIcon icon={faStore} />
          </StoreIconWrapper>
          <StoreDetails>
            <StoreName $isDark={isDark}>{storeGroup.storeName}</StoreName>
            <MerchantName $isDark={isDark}>{storeGroup.merchantName}</MerchantName>
          </StoreDetails>
        </StoreInfo>
        <StoreActions>
          <DeviceCountTag $isDark={isDark}>{countLabel}</DeviceCountTag>
          <ToggleButton
            $isDark={isDark}
            type="text"
            icon={
              <FontAwesomeIcon icon={isExpanded ? faChevronUp : faChevronDown} />
            }
            onClick={() => setIsExpanded((prev) => !prev)}
          />
        </StoreActions>
      </StoreHeader>

      {isExpanded && (
        <ExpandableContent>
          <DevicesGrid>
            {storeGroup.devices.map((device) => (
              <DeviceCard
                key={device.id}
                device={device}
                isDark={isDark}
                onEdit={onEditDevice}
                onDelete={onDeleteDevice}
              />
            ))}
          </DevicesGrid>
        </ExpandableContent>
      )}
    </StoreCard>
  );
};

export default StoreGroupCard;
